<template>
  <ion-page>
    <master-layout pageTitle="لیست مدیران">
      <ion-card>
        <ion-card-content>
          <router-link to="/Admin/Add" class="btn btn-success">افزودن مدیر جدید</router-link>
          <DataTable :headers="headers" route="admin/listAjax"></DataTable>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
  IonCard, IonCardContent, IonPage
} from "@ionic/vue";

export default {
  data()
  {
    return {
      id:null,
      headers:[
        'نام کامل',
        'شماره تلفن',
        'امکانات'
      ]
    };
  },
  async created()
  {
    // this.id = this.$route.params.id;
  },
  components: {
    IonCard, IonCardContent, DataTable, IonPage
  }
};
</script>

<style scoped>

</style>